import { InputAdornment } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PriceInput.css';
import { MAP_TO_RADIX, MAX_PRICE, MIN_PRICE, POSTFIX, PRICE_SEPARATOR } from './constants';
import { MaskedInput } from '../MaskedInput';

interface IPriceInputProps {
  value: number | null;
  onChange?(value: number | null): void;
}

export const PriceInput: React.FC<IPriceInputProps> = ({ value, onChange }) => {
  const handleChange = React.useCallback(
    (valueRaw: string) => {
      const nextValue = valueRaw ? Number(valueRaw) : null;
      if (nextValue === value) {
        return;
      }

      if (onChange) {
        onChange(nextValue);
      }
    },
    [value, onChange],
  );

  return (
    <MaskedInput
      rightAdornment={
        <InputAdornment>
          <span className={styles['postfix']}>{POSTFIX}</span>
        </InputAdornment>
      }
      mask={Number}
      min={MIN_PRICE}
      max={MAX_PRICE}
      placeholder="0"
      thousandsSeparator={PRICE_SEPARATOR}
      mapToRadix={MAP_TO_RADIX}
      value={getValue(value)}
      onComplete={handleChange}
    />
  );
};

function getValue(value: number | null | undefined): string {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }

  return String(value);
}
